import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, messageErreur } from "@/lib/api";

export default function Partenaires() {
  const { user } = useAuth();
  const gerer = user.role === "dirigeant";
  const [liste, setListe] = useState([]);
  const [nom, setNom] = useState("");
  const [ville, setVille] = useState("");
  const charger = useCallback(() => api.get("/partenaires").then((r) => setListe(r.data)), []);
  useEffect(() => { charger(); }, [charger]);

  const creer = async (e) => {
    e.preventDefault();
    try { await api.post("/partenaires", { nom, ville }); toast.success("Société partenaire créée."); setNom(""); setVille(""); charger(); }
    catch (err) { toast.error(messageErreur(err)); }
  };
  const supprimer = async (p) => {
    try { const { data } = await api.delete(`/partenaires/${p.id}`); toast.success(data.message); charger(); }
    catch (err) { toast.error(messageErreur(err)); }
  };

  return (
    <div className="space-y-4">
      <h2 className="text-base md:text-lg font-bold">Sociétés partenaires</h2>
      {gerer && (
        <form onSubmit={creer} className="at-card p-4 flex flex-col sm:flex-row gap-2" data-testid="partner-form">
          <input className="at-input" placeholder="Nom de la société" required value={nom} onChange={(e) => setNom(e.target.value)} data-testid="partner-name-input" />
          <input className="at-input" placeholder="Ville" value={ville} onChange={(e) => setVille(e.target.value)} data-testid="partner-city-input" />
          <button type="submit" className="at-btn at-btn-primary shrink-0" data-testid="partner-create-button"><Plus size={17} />Ajouter</button>
        </form>
      )}
      <div className="grid sm:grid-cols-2 gap-3" data-testid="partners-list">
        {liste.map((p) => (
          <div key={p.id} className="at-fiche p-4 flex items-center justify-between gap-3" data-testid={`partner-card-${p.id}`}>
            <div className="min-w-0"><p className="font-bold truncate">{p.nom}</p><p className="text-sm at-muted">{p.ville || "—"} · {p.nb_utilisateurs} utilisateur{p.nb_utilisateurs > 1 ? "s" : ""}</p></div>
            {gerer && <button type="button" className="at-icon-btn" aria-label="Mettre à la corbeille" onClick={() => supprimer(p)} data-testid={`partner-delete-${p.id}`}><Trash2 size={17} /></button>}
          </div>
        ))}
      </div>
    </div>
  );
}
